import React, { useState } from 'react';
import './DigitalIDCard.css';
import { MdPhone, MdEmail, MdContentCopy } from 'react-icons/md';

const DigitalIDCard = ({ cardData, isPreview = false }) => {
  const [showInstructionsPopup, setShowInstructionsPopup] = useState(false);
  const [showContactInfoPopup, setShowContactInfoPopup] = useState(false);
  const [selectedTab, setSelectedTab] = useState('ios');
  const {
    name = "Leo Schleifer",
    position = "DIRECTOR",
    contact_info = {
      phone: "+6221 59992864",
      whatsapp: "+62 896 7883 1698",
      email: "leo@jethero.com"
    },
    address = "Dalton Timur Blok DLTN No.36 Jl. Scientia Selatan, Gading Serpong. Tangerang 15810",
    social_media = {
      linkedin: "https://linkedin.com/in/leo",
      instagram: "@leo_jethero"
    },
    profile_image = "/assets/2559.jpg",
    company_logo = "/assets/jethro.svg",
    company_name = "Jethero HQ",
    visibility = {
      show_phone: true,
      show_whatsapp: true
    }
  } = cardData || {};

  const handleWhatsAppClick = () => {
    if (!isPreview && contact_info.whatsapp) {
      const cleanNumber = contact_info.whatsapp.replace(/[^0-9]/g, '');
      const message = encodeURIComponent(`Hello ${name}, I got your contact from your Digital ID card.`);
      window.open(`https://wa.me/${cleanNumber}?text=${message}`, '_blank');
    }
  };

  const handleSaveToPhonebook = () => {
    if (!isPreview) {
      // Split name for vCard N field (Last;First;Middle;Prefix;Suffix)
      const nameParts = name.trim().split(/\s+/);
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || '';
      
      const vCardData = `BEGIN:VCARD
VERSION:3.0
N:${lastName};${firstName};;;
FN:${name}
ORG:${company_name || ''}
TITLE:${position || ''}
TEL;TYPE=WORK,VOICE:${contact_info?.phone || ''}
TEL;TYPE=CELL,VOICE:${contact_info?.whatsapp || ''}
EMAIL:${contact_info?.email || ''}
ADR;TYPE=WORK:;;${address || ''};;;;
URL:${social_media?.linkedin || ''}
END:VCARD`;
      
      // Detect if Safari/iOS
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      if (isSafari || isIOS) {
        const dataUri = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(vCardData);
        const link = document.createElement('a');
        link.href = dataUri;
        link.download = `${name.replace(/\s+/g, '_')}.vcf`;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const blob = new Blob([vCardData], { type: 'text/vcard;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${name.replace(/\s+/g, '_')}.vcf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
  };

  const handleDownloadVCard = () => {
    const nameParts = name.trim().split(/\s+/);
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';
    
    const vCardData = `BEGIN:VCARD
VERSION:3.0
N:${lastName};${firstName};;;
FN:${name}
ORG:${company_name}
TITLE:${position}
TEL;TYPE=WORK:${contact_info.phone}
TEL;TYPE=CELL:${contact_info.whatsapp}
EMAIL:${contact_info.email}
ADR;TYPE=WORK:;;${address};;;;
URL:${social_media.linkedin}
END:VCARD`;

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isSafari || isIOS) {
      const dataUri = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(vCardData);
      const link = document.createElement('a');
      link.href = dataUri;
      link.download = `${name.replace(/\s+/g, '_')}.vcf`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const blob = new Blob([vCardData], { type: 'text/vcard' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${name.replace(/\s+/g, '_')}.vcf`;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  };

  const closeInstructionsPopup = () => {
    setShowInstructionsPopup(false);
  };

  const handleTabSwitch = (tab) => {
    setSelectedTab(tab);
  };

  const handleSocialMediaClick = () => {
    if (!isPreview && social_media.linkedin) {
      window.open(social_media.linkedin, '_blank');
    }
  };

  const handleContactInfoClick = () => {
    if (!isPreview) {
      setShowContactInfoPopup(true);
    }
  };

  const closeContactInfoPopup = () => {
    setShowContactInfoPopup(false);
  };

  const handleCopyToClipboard = (text, type) => {
    if (!isPreview) {
      navigator.clipboard.writeText(text).then(() => {
        console.log(`${type} copied to clipboard: ${text}`);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  };

  const handlePhoneCall = (phoneNumber) => {
    if (!isPreview && phoneNumber) {
      const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
      window.location.href = `tel:${cleanNumber}`;
    }
  };

  const handleEmailClick = (email) => {
    if (!isPreview && email) {
      window.location.href = `mailto:${email}`;
    }
  };

  return (
    <div className="digital-id-container">
      <div className="c_desktop1-frame10">
        {/* Header image di paling atas dengan konten profile di dalamnya */}
        <div style={{ position: 'relative', zIndex: 2 }}>
          <img
            src="/assets/header.svg"
            alt="Header Design"
            width="375"
            height="247.99999891902178"
            className="c_desktop1-frame16"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
          
          {/* Konten profile di atas header */}
          <div 
            style={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div className="c_desktop1-frame11">
              <div className="c_desktop1-frame12">
                <img
                  src={profile_image || "/assets/2559.jpg"}
                  alt="Profile"
                  width="80"
                  height="80"
                  className="c_desktop1-frame13"
                  onError={(e) => {
                    e.target.src = "/assets/2559.jpg";
                  }}
                />
                <div className="c_desktop1-frame14">
                  <img
                    src="/assets/jethro.svg"
                    alt="Company Logo"
                    width="70"
                    height="17"
                    className="c_desktop1-frame15"
                    onError={(e) => {
                      e.target.src = "/assets/jethro.svg";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Nama dan posisi di bawah header */}
        <div style={{ 
          position: 'relative', 
          zIndex: 2, 
          marginTop: '10px', 
          paddingTop: '20px' 
        }}>
          <div className="c_desktop1-text10">
            <p className="c_desktop1-text11">{name}</p>
          </div>
          <div className="c_desktop1-text12">
            <p className="c_desktop1-text13">{position}</p>
          </div>
        </div>
        
        <div className="c_desktop1-text14">
          <p className="c_desktop1-text15">
            <span className="c_desktop1-text16">Hello there, I'm </span>
            <span className="c_desktop1-text17">{name.split(' ')[0]}.</span>
            <br />
            <span className="c_desktop1-text18">
               Please don't hesitate to save and <br />contact me.
            </span>
          </p>
        </div>
        
        <div className="c_desktop1-frame17">
          <div className="c_desktop1-frame18" onClick={handleContactInfoClick} style={{cursor: isPreview ? 'default' : 'pointer'}}>
            <img
              src="/assets/BlackUser.svg"
              alt="Contact Info"
              width="32"
              height="32"
              className="c_desktop1-instance1"
            />
            <div className="c_desktop1-text19">
              <p className="c_desktop1-text20">Contact Info</p>
            </div>
          </div>
          
          <div className="c_desktop1-frame19" onClick={handleWhatsAppClick} style={{cursor: isPreview ? 'default' : 'pointer'}}>
            <img
              src="/assets/BlackWA.svg"
              alt="WhatsApp"
              width="32"
              height="32"
              className="c_desktop1-instance3"
            />
            <div className="c_desktop1-text21">
              <p className="c_desktop1-text22">Whatsapp Chat</p>
            </div>
          </div>
          
          <div className="c_desktop1-frame20" onClick={handleSocialMediaClick} style={{cursor: isPreview ? 'default' : 'pointer'}}>
            <img
              src="/assets/BlackPlayslist.svg"
              alt="Social Media"
              width="32"
              height="32"
              className="c_desktop1-instance2"
            />
            <div className="c_desktop1-text23">
              <p className="c_desktop1-text24">Social Media</p>
            </div>
          </div>
        </div>
        
        <div className="c_desktop1-frame21" style={{cursor: isPreview ? 'default' : 'pointer'}}>
          <div className="c_desktop1-frame22" onClick={() => !isPreview && setShowInstructionsPopup(true)}>
            <div className="c_desktop1-text25">
              <p className="c_desktop1-text26">Save to phonebook</p>
            </div>
            <div className="c_desktop1-text27">
              <p className="c_desktop1-text28">Click to see the instructions</p>
            </div>
          </div>
          <div className="c_desktop1-frame23" onClick={handleSaveToPhonebook}>
            {/* Animated shadow layer (background) */}
            <img
              src="/assets/circle.svg"
              alt=""
              width="44"
              height="44"
              className="c_desktop1-instance3 pulse-shadow-layer"
              style={{ position: 'absolute' }}
            />
            {/* Static circle layer (foreground) */}
            <img
              src="/assets/circle.svg"
              alt="Save"
              width="44"
              height="44"
              className="c_desktop1-instance3"
              style={{ position: 'relative', zIndex: 1 }}
            />
          </div>
        </div>
        
        <div className="c_desktop1-frame24">
          <div className="c_desktop1-frame25">
            <a 
              href={`https://maps.google.com/?q=${encodeURIComponent(address)}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', display: 'block' }}
              title="Open in Google Maps"
            >
              <div className="c_desktop1-frame26">
                <div className="c_desktop1-frame27">
                  <div className="c_desktop1-text29">
                    <p className="c_desktop1-text30">{company_name || "Jethero HQ"}</p>
                  </div>
                  <div className="c_desktop1-text31">
                    <p className="c_desktop1-text32">{address}</p>
                  </div>
                </div>
                <div className="c_desktop1-frame28">
                  <img
                    src="/assets/redLocation.svg"
                    alt="Location"
                    width="24"
                    height="24"
                    className="c_desktop1-instance4"
                  />
                </div>
              </div>
            </a>
            
            {/* Office Phone - only show if visibility.show_phone is true */}
            {visibility?.show_phone !== false && (
              <div className="c_desktop1-frame29">
                <div className="c_desktop1-frame30">
                  <div className="c_desktop1-text33">
                    <p className="c_desktop1-text34">Office Phone</p>
                  </div>
                  <div className="c_desktop1-text35">
                    <p className="c_desktop1-text36">{contact_info.phone}</p>
                  </div>
                </div>
                <div className="c_desktop1-frame31">
                  <img
                    src="/assets/redCall.svg"
                    alt="Phone"
                    width="24"
                    height="24"
                    className="c_desktop1-instance5"
                  />
                </div>
              </div>
            )}
            
            {/* WhatsApp Pribadi - only show if visibility.show_whatsapp is true */}
            {visibility?.show_whatsapp !== false && (
              <div className="c_desktop1-frame32">
                <div className="c_desktop1-frame33">
                  <div className="c_desktop1-text37">
                    <p className="c_desktop1-text38">Office WA Business</p>
                  </div>
                  <div className="c_desktop1-text39">
                    <p className="c_desktop1-text40">{contact_info.whatsapp}</p>
                  </div>
                </div>
                <div className="c_desktop1-frame34">
                  <div className="c_desktop1-group2">
                    <img
                      src="/assets/redWA.svg"
                      alt="WhatsApp Business"
                      width="24"
                      height="23.99951171875"
                      className="c_desktop1-vector4"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="c_desktop1-frame35">
            <img
              src="/assets/pattern.svg"
              alt="Pattern"
              width="87.61921920464852"
              height="52.29081058948361"
              className="c_desktop1-frame36"
            />
          </div>
        </div>
        
        <div className="c_desktop1-text41">
          <p className="c_desktop1-text42">Version 1.0.0</p>
          <p className="c_desktop1-text43">© Jethro.inc - PhyGital ( Physical & Digital Agency )</p>
        </div>
        
        <img
          src="/assets/footer.svg"
          alt="Footer"
          width="375"
          height="38"
          className="c_desktop1-frame37"
        />
      </div>
      
    
      {/* Contact Info Popup */}
      {showContactInfoPopup && (
        <div className="popup-overlay" onClick={closeContactInfoPopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="c_frame26-frame10">
              <div className="c_frame26-frame11">
                <img
                  src="/assets/3didcard.png"
                  alt="rectangle"
                  width="57.8525390625"
                  height="72.6793212890625"
                  className="c_frame26-rectangle"
                />
                <div className="c_frame26-text10">
                  <p className="c_frame26-text11">Contact Information</p>
                </div>
                
                <div className="c_frame26-frame15">
                  <div className="c_frame26-frame16">
                    <div className="c_frame26-frame17">
                      <div className="c_frame26-text16">
                        <MdPhone className="c_frame26-text17" />
                      </div>
                    </div>
                    <div className="c_frame26-frame18">
                      <div className="c_frame26-text18">
                        <p className="c_frame26-text19">Phone Number</p>
                      </div>
                      <div className="c_frame26-text18" style={{display: 'flex', alignItems: 'center', gap: '8px', width: '100%'}}>
                        <p className="c_frame26-text19" style={{fontWeight: '600', color: '#0079bf', flex: 1}}>
                          {contact_info.whatsapp}
                        </p>
                        <div style={{display: 'flex', gap: '4px'}}>
                          <button 
                            onClick={() => handleCopyToClipboard(contact_info.whatsapp, 'WhatsApp')}
                            style={{
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: '14px',
                              padding: '4px'
                            }}
                            title="Copy phone number"
                          >
                            <MdContentCopy />
                          </button>
                          <button 
                            onClick={() => handlePhoneCall(contact_info.whatsapp)}
                            style={{
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: '14px',
                              padding: '4px'
                            }}
                            title="Call phone number"
                          >
                            <MdPhone />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="c_frame26-frame20">
                    <div className="c_frame26-frame21">
                      <div className="c_frame26-text22">
                        <MdEmail className="c_frame26-text23" />
                      </div>
                    </div>
                    <div className="c_frame26-frame22">
                      <div className="c_frame26-text24">
                        <p className="c_frame26-text25">Email Address</p>
                      </div>
                      <div className="c_frame26-text24" style={{display: 'flex', alignItems: 'center', gap: '8px', width: '100%'}}>
                        <p className="c_frame26-text25" style={{fontWeight: '600', color: '#0079bf', flex: 1}}>
                          {contact_info.email}
                        </p>
                        <div style={{display: 'flex', gap: '4px'}}>
                          <button 
                            onClick={() => handleCopyToClipboard(contact_info.email, 'Email')}
                            style={{
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: '14px',
                              padding: '4px'
                            }}
                            title="Copy email address"
                          >
                            <MdContentCopy />
                          </button>
                          <button 
                            onClick={() => handleEmailClick(contact_info.email)}
                            style={{
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: '14px',
                              padding: '4px'
                            }}
                            title="Send email"
                          >
                            <MdEmail />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="c_frame26-frame26">
                  <div className="c_frame26-frame27" onClick={closeContactInfoPopup} style={{cursor: 'pointer'}}>
                    <div className="c_frame26-text30">
                      <p className="c_frame26-text31">Close</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  )}

    {/* Instructions Popup */}
    {showInstructionsPopup && (
        <div className="popup-overlay" onClick={closeInstructionsPopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            {selectedTab === 'ios' ? (
              // iOS Version
              <div className="c_frame26-frame10">
                <div className="c_frame26-frame11">
                  <img
                    src="/assets/3didcard.png"
                    alt="rectangle"
                    width="57.8525390625"
                    height="72.6793212890625"
                    className="c_frame26-rectangle"
                  />
                  <div className="c_frame26-text10">
                    <p className="c_frame26-text11">How to save contacts to your phonebook:</p>
                  </div>
                  <div className="c_frame26-frame12">
                    <div 
                      className="c_frame26-frame13" 
                      onClick={() => handleTabSwitch('android')}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: selectedTab === 'android' ? '#000' : 'transparent',
                        border: selectedTab === 'android' ? 'none' : '1px solid #bebebe'
                      }}
                    >
                      <div className="c_frame26-text12">
                        <p className="c_frame26-text13" style={{
                          color: selectedTab === 'android' ? '#fff' : '#bebebe'
                        }}>Android</p>
                      </div>
                    </div>
                    <div 
                      className="c_frame26-frame14"
                      style={{
                        backgroundColor: selectedTab === 'ios' ? '#000' : 'transparent',
                        border: selectedTab === 'ios' ? 'none' : '1px solid #bebebe'
                      }}
                    >
                      <div className="c_frame26-text14">
                        <p className="c_frame26-text15" style={{
                          color: selectedTab === 'ios' ? '#fff' : '#bebebe'
                        }}>iOS</p>
                      </div>
                    </div>
                  </div>
                  <div className="c_frame26-frame15">
                    <div className="c_frame26-frame16">
                      <div className="c_frame26-frame17">
                        <div className="c_frame26-text16">
                          <p className="c_frame26-text17">1</p>
                        </div>
                      </div>
                      <div className="c_frame26-frame18">
                        <div className="c_frame26-text18">
                          <p className="c_frame26-text19">Click Download button below</p>
                        </div>
                        <div className="c_frame26-frame19" onClick={handleDownloadVCard} style={{cursor: 'pointer'}}>
                          <img
                            src="/assets/2599.png"
                            alt="vector"
                            width="18"
                            height="18"
                            className="c_frame26-vector"
                          />
                          <div className="c_frame26-text20">
                            <p className="c_frame26-text21">Download</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="c_frame26-frame20">
                      <div className="c_frame26-frame21">
                        <div className="c_frame26-text22">
                          <p className="c_frame26-text23">2</p>
                        </div>
                      </div>
                      <div className="c_frame26-frame22">
                        <div className="c_frame26-text24">
                          <p className="c_frame26-text25">
                            Contacts app popup will automatically show, please click Create
                            New Contact to save to your phonebook
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="c_frame26-frame23">
                      <div className="c_frame26-frame24">
                        <div className="c_frame26-text26">
                          <p className="c_frame26-text27">3</p>
                        </div>
                      </div>
                      <div className="c_frame26-frame25">
                        <div className="c_frame26-text28">
                          <p className="c_frame26-text29">
                            New contact Popup automatically show, scroll down to see all
                            information and click Done to save
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="c_frame26-frame26">
                    <div className="c_frame26-frame27" onClick={closeInstructionsPopup} style={{cursor: 'pointer'}}>
                      <div className="c_frame26-text30">
                        <p className="c_frame26-text31">Done</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Android Version
              <div className="c_frame25-frame10">
                <div className="c_frame25-frame11">
                  <img
                    src="/assets/3didcard.png"
                    alt="rectangle"
                    width="57.8525390625"
                    height="72.67930603027344"
                    className="c_frame25-rectangle"
                  />
                  <div className="c_frame25-text10">
                    <p className="c_frame25-text11">How to save contacts to your phonebook:</p>
                  </div>
                  <div className="c_frame25-frame12">
                    <div 
                      className="c_frame25-frame13"
                      style={{
                        backgroundColor: selectedTab === 'android' ? '#000' : 'transparent',
                        border: selectedTab === 'android' ? 'none' : '1px solid #bebebe'
                      }}
                    >
                      <div className="c_frame25-text12">
                        <p className="c_frame25-text13" style={{
                          color: selectedTab === 'android' ? '#fff' : '#bebebe'
                        }}>Android</p>
                      </div>
                    </div>
                    <div 
                      className="c_frame25-frame14" 
                      onClick={() => handleTabSwitch('ios')}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: selectedTab === 'ios' ? '#000' : 'transparent',
                        border: selectedTab === 'ios' ? 'none' : '1px solid #bebebe'
                      }}
                    >
                      <div className="c_frame25-text14">
                        <p className="c_frame25-text15" style={{
                          color: selectedTab === 'ios' ? '#fff' : '#bebebe'
                        }}>iOS</p>
                      </div>
                    </div>
                  </div>
                  <div className="c_frame25-frame15">
                    <div className="c_frame25-frame16">
                      <div className="c_frame25-frame17">
                        <div className="c_frame25-text16">
                          <p className="c_frame25-text17">1</p>
                        </div>
                      </div>
                      <div className="c_frame25-frame18">
                        <div className="c_frame25-text18">
                          <p className="c_frame25-text19">Click Download button below</p>
                        </div>
                        <div className="c_frame25-frame19" onClick={handleDownloadVCard} style={{cursor: 'pointer'}}>
                          <img
                            src="/assets/2599.png"
                            alt="vector"
                            width="18"
                            height="18"
                            className="c_frame25-vector"
                          />
                          <div className="c_frame25-text20">
                            <p className="c_frame25-text21">Download</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="c_frame25-frame20">
                      <div className="c_frame25-frame21">
                        <div className="c_frame25-text22">
                          <p className="c_frame25-text23">2</p>
                        </div>
                      </div>
                      <div className="c_frame25-frame22">
                        <div className="c_frame25-text24">
                          <p className="c_frame25-text25">Open VCF file to save to phonebook</p>
                        </div>
                        <div className="c_frame25-text26">
                          <p className="c_frame25-text27">
                            VCF file extension is a vCard file, it is secure to save. Open
                            with Contacts to save.
                          </p>
                        </div>
                        <div className="c_frame25-frame23">
                          <div className="c_frame25-text28">
                            <p className="c_frame25-text29">Now</p>
                          </div>
                          <div className="c_frame25-frame24">
                            <div className="c_frame25-text30">
                              <p className="c_frame25-text31">Downloaded 1 file</p>
                            </div>
                            <div className="c_frame25-text32">
                              <p className="c_frame25-text33">JETHRO.vcf</p>
                            </div>
                          </div>
                          <div className="c_frame25-text34">
                            <p className="c_frame25-text35">Locate file</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="c_frame25-frame25">
                      <div className="c_frame25-frame26">
                        <div className="c_frame25-text36">
                          <p className="c_frame25-text37">3</p>
                        </div>
                      </div>
                      <div className="c_frame25-frame27">
                        <div className="c_frame25-text38">
                          <p className="c_frame25-text39">
                            <span className="c_frame25-text40">Click </span>
                            <span className="c_frame25-text41">YES</span>
                            <span className="c_frame25-text42"> to import contacts from vCard.</span>
                          </p>
                        </div>
                        <div className="c_frame25-text43">
                          <p className="c_frame25-text44">
                            VCF file extension is a vCard file, it is secure to save. Open
                            with Contacts to save.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="c_frame25-frame28">
                    <div className="c_frame25-frame29" onClick={closeInstructionsPopup} style={{cursor: 'pointer'}}>
                      <div className="c_frame25-text45">
                        <p className="c_frame25-text46">Done</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalIDCard;
